import { Message, SessionMessageRecord } from '../types';

// Cosmos stores one record per query/response exchange. The chat UI works in
// terms of individual user/assistant messages, so each record expands to up to two.
export function mapSessionRecordsToMessages(records: unknown[]): Message[] {
  const messages: Message[] = [];

  for (const record of records || []) {
    const rec = record as SessionMessageRecord;
    const isExchangeRecord = rec && typeof rec === 'object' && ('query' in rec || 'response' in rec);

    if (!isExchangeRecord) {
      messages.push(record as Message);
      continue;
    }

    if (rec.query) {
      messages.push({ role: 'user', content: rec.query, timestamp: rec.timestamp });
    }
    if (rec.response) {
      messages.push({
        role: 'assistant',
        content: rec.response,
        timestamp: rec.timestamp,
        stations: rec.stations,
        encodedPolyline: rec.route?.encodedPolyline,
        extraction: rec.extraction as Message['extraction'],
      });
    }
  }

  return messages;
}
